module.exports = __webpack_public_path__ + "img/sedang_direview_oleh_asuransi.eb4caf14.svg";